import { createFileRoute } from "@tanstack/react-router";

import { loadBlogPostPage } from "@/features/blog/load-blog-post-detail";
import { buildBlogPostHead } from "@/features/blog/route-data";
import { BlogDetailScreen } from "@/features/blog/screens/BlogDetailScreen";

export const Route = createFileRoute("/_landing/blog/$slug")({
  loader: ({ params }) => loadBlogPostPage("en", params.slug),
  head: ({ loaderData }) => buildBlogPostHead({ loaderData }),
  component: BlogPostRoute,
});

function BlogPostRoute() {
  return <BlogDetailScreen data={Route.useLoaderData()} />;
}
